import {Component, ViewChild}        from '@angular/core';
import {ApFertilizerOrgsComponent}   from './ap-fertilizer-orgs.component';
import {ApFertilizerInorgsComponent} from './ap-fertilizer-inorgs.component';
import {IApPermissionData}           from '../../ap-interface';
import {ApPermissions}               from 'invoker-transport';
import {
  ApFertilizerInorgsEditComponent
}                                    from '../../entry-components/ap-basedata-entry-components/ap-fertilizer-inorgs-edit.component';
import {
  ApFertilizerOrgsEditComponent
}                                    from '../../entry-components/ap-basedata-entry-components/ap-fertilizer-orgs-edit.component';
import {FormStore}                   from '../../stores/layout/form.store';
import {MapViewStore}                from '../../stores/layout/mapview.store';

/**
 * Enumeration of all fertilizer tabs
 */
export enum FertilizerTabs {
  FertilizerOrg = 0,
  FertilizerInorg = 1
}

/**
 * Component for the fertilizers
 */
@Component({
  selector: 'ap-fertilizers-overview',
  templateUrl: 'ap-fertilizers.component.html',
})

export class ApFertilizersOverviewComponent {
  public apPermissionData: IApPermissionData;
  public ApPermissions = ApPermissions;
  public selectedTab: FertilizerTabs = FertilizerTabs.FertilizerOrg;

  @ViewChild(ApFertilizerOrgsComponent, {static: false})
  public fertilizerOrgsOverviewComponent: ApFertilizerOrgsComponent;

  @ViewChild(ApFertilizerInorgsComponent, {static: false})
  public fertilizerInOrgsOverviewComponent: ApFertilizerInorgsComponent;

  constructor(private formStore: FormStore,
              private mapViewStore: MapViewStore) {
    this.mapViewStore.hideMapView();
  }

  public searchIn(value: string): void {
    switch (this.selectedTab) {
      case FertilizerTabs.FertilizerOrg:
        this.fertilizerOrgsOverviewComponent.dynComponent?.dynGrid?.filterGrid(value);
        break;
      case FertilizerTabs.FertilizerInorg:
        this.fertilizerInOrgsOverviewComponent.dynComponent?.dynGrid?.filterGrid(value);
        break;
    }
  }

  public createNew(): void {
    let fertilizerComponent: any;
    switch (this.selectedTab) {
      case FertilizerTabs.FertilizerOrg:
        fertilizerComponent = ApFertilizerOrgsEditComponent;
        break;
      case FertilizerTabs.FertilizerInorg:
        fertilizerComponent = ApFertilizerInorgsEditComponent;
        break;
    }
    this.formStore.openForm({component: fertilizerComponent, data: null});
  }

  public selectTab(e: any): void {
    switch (this.selectedTab) {
      case FertilizerTabs.FertilizerOrg:
        this.fertilizerOrgsOverviewComponent.dynComponent?.dynGrid.filterGrid('');
        break;
      case FertilizerTabs.FertilizerInorg:
        this.fertilizerInOrgsOverviewComponent.dynComponent?.dynGrid.filterGrid('');
        break;
    }
    this.selectedTab = e.index;
  }
}
